import { render, staticRenderFns } from "./screen-share-dialog.vue?vue&type=template&id=bb38e156&"
import script from "./screen-share-dialog.vue?vue&type=script&lang=js&"
export * from "./screen-share-dialog.vue?vue&type=script&lang=js&"
import style0 from "./screen-share-dialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports